import { render, staticRenderFns } from "./organization-manage.vue?vue&type=template&id=2d2f3947&scoped=true"
import script from "./organization-manage.vue?vue&type=script&lang=js"
export * from "./organization-manage.vue?vue&type=script&lang=js"
import style0 from "./organization-manage.vue?vue&type=style&index=0&id=2d2f3947&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2f3947",
  null
  
)

export default component.exports